import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import { Modal } from "react-bootstrap";
import { Addstocks } from "./addstocks";
import moment from "moment";
import { AddTemplateModal } from "./addTemplateModal";
import { AddTemplateCategory } from "./addTemplateCategory";

export function AddTemplate({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showCategory, setShowCategory] = useState(false);
  const handleCloseCategory = () => setShowCategory(false);
  const handleShowCategory = () => setShowCategory(true);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [allCategory, setAllCategory] = useState([]);

  // console.log(window.location);
  // console.log(match.url);
  const getTemplate = async () => {
    try {
      setLoader(true);
      let payload = {
        category: selectedCategory ? selectedCategory : "",
      };
      const postData = await api.getTemplate(payload);
      setData(postData.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };
  const getTemplateCategory = async () => {
    try {
      setLoader(true);
      const response = await api.getTemplateCategory();
      setAllCategory(response.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    try {
      let payload = {
        id: id,
      };
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this template?"
      );
      if (isConfirmed) {
        const userData = await api.deleteTemplate(payload);
        console.log("deleted");
        getTemplate();
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getTemplate();
  }, [selectedCategory]);

  useEffect(() => {
    getTemplateCategory();
  }, []);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="row">
          {/* Area Chart */}
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12 d-flex justify-content-between pr-0 flex-wrap">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  Templates ({data?.length || 0})
                </h4>
                {(adminType == "mackAdmin777" ||
                  adminType == "jackAdmin775" ||
                  adminStore?.admin?.admin?.email == "alex@waqarzaka.net" ||
                  adminStore?.admin?.admin?.email == "sarah@waqarzaka.net") && (
                  <button className="themeBtn" onClick={handleShow}>
                    Add Template
                  </button>
                )}
              </div>
              <div className="col-12 d-flex justify-content-between ai-center pr-0 flex-wrap mt-4">
                <div className="categoryTab">
                  <button
                    className={!selectedCategory ? "active" : ""}
                    onClick={() => setSelectedCategory("")}
                  >
                    All
                  </button>
                  {allCategory.map((val, key) => (
                    <button
                      key={key}
                      onClick={() => setSelectedCategory(val?._id)}
                      className={selectedCategory == val?._id ? "active" : ""}
                    >
                      {val?.name}
                    </button>
                  ))}
                </div>
                {(adminType == "mackAdmin777" ||
                  adminType == "jackAdmin775" ||
                  adminStore?.admin?.admin?.email == "alex@waqarzaka.net" ||
                  adminStore?.admin?.admin?.email == "sarah@waqarzaka.net") && (
                  <button
                    className="themeBlackBtn"
                    onClick={handleShowCategory}
                  >
                    Add Category
                  </button>
                )}
              </div>
            </div>
            {/* table */}
            {/* table */}
            {data?.map((val, key) => (
              <div className="templateMain" key={key}>
                <div className="title">
                  {val?.title}
                  <span
                    onClick={() => deletePost(val?._id)}
                    className="cursor-pointer"
                  >
                    <i class="fa-solid fa-trash-can"></i>
                  </span>
                </div>
                <div className="tempCard">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: val?.template,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {/* /.container-fluid */}
      <Modal show={show} size="lg" onHide={handleClose} centered className="">
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleClose}>
              <i className="fa-solid fa-xmark" />
            </div>
            <AddTemplateModal
              getTemplate={getTemplate}
              setShow={setShow}
              allCategory={allCategory}
            />
          </div>
        </Modal.Body>
      </Modal>
      {/* add category modal */}
      <Modal
        show={showCategory}
        size="lg"
        onHide={handleCloseCategory}
        centered
        className=""
      >
        <Modal.Body>
          <div className="otpModalMain">
            <div className="closeIcon" onClick={handleCloseCategory}>
              <i className="fa-solid fa-xmark" />
            </div>
            <AddTemplateCategory
              getTemplateCategory={getTemplateCategory}
              setShow={setShowCategory}
            />
          </div>
        </Modal.Body>
      </Modal>
      {loader && <Loader />}
    </>
  );
}
